module.exports = __webpack_public_path__ + "img/L1_Frame.1c77fbe6.svg";